import React from 'react';
import { Button, Typography, Space } from 'antd';
import { CheckCircleFilled, EyeOutlined, PlusOutlined, AppstoreOutlined, ClockCircleOutlined, MessageOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const PAYMENT_WHATSAPP_NUMBER = '00905348293526';

const WizardDoneStep = ({ auctionSlug, auctionTitle, lotCount, onAddMore }) => {
    const navigate = useNavigate();

    const handleContactForPayment = () => {
        const message = encodeURIComponent(
            `Hello, I'd like to complete payment to activate my auction "${auctionTitle}".`
        );
        window.open(`https://wa.me/${PAYMENT_WHATSAPP_NUMBER}?text=${message}`, '_blank');
    };

    return (
        <div style={{ textAlign: 'center', padding: '24px 0' }}>
            <CheckCircleFilled style={{ fontSize: 72, color: '#52c41a', marginBottom: 16 }} />
            <Title level={2} style={{ marginBottom: 4 }}>🎉 All Done!</Title>
            <Text style={{ fontSize: 17, color: '#595959', display: 'block', marginBottom: 20 }}>
                "{auctionTitle}" is created with {lotCount} lot{lotCount === 1 ? '' : 's'}.
            </Text>

            <div style={{
                background: '#fff7e6',
                border: '1px solid #ffd591',
                borderRadius: 14,
                padding: '16px 20px',
                marginBottom: 24,
                maxWidth: 420,
                margin: '0 auto 24px',
                textAlign: 'left'
            }}>
                <Space align="start">
                    <ClockCircleOutlined style={{ fontSize: 20, color: '#fa8c16', marginTop: 2 }} />
                    <div>
                        <Text strong style={{ fontSize: 15, color: '#874d00' }}>
                            One more step: complete payment
                        </Text>
                        <Text style={{ display: 'block', fontSize: 13, color: '#874d00', marginTop: 4 }}>
                            Your auction is set to <strong>Scheduled</strong> and won't be visible to bidders yet.
                            Complete payment to make it <strong>Active</strong>.
                        </Text>
                    </div>
                </Space>
                <Button
                    block
                    size="large"
                    icon={<MessageOutlined />}
                    onClick={handleContactForPayment}
                    style={{
                        marginTop: 14,
                        height: 48,
                        fontSize: 15,
                        fontWeight: 600,
                        borderRadius: 10,
                        background: '#25D366',
                        borderColor: '#25D366',
                        color: '#fff'
                    }}
                >
                    Contact Us on WhatsApp to Pay
                </Button>
            </div>

            <Space direction="vertical" size={12} style={{ width: '100%', maxWidth: 360, margin: '0 auto' }}>
                <Button
                    type="primary"
                    block
                    size="large"
                    icon={<EyeOutlined />}
                    onClick={() => navigate(`/auctions/${auctionSlug}`)}
                    style={{ height: 56, fontSize: 17, fontWeight: 700, borderRadius: 14 }}
                >
                    View My Auction
                </Button>
                <Button
                    block
                    size="large"
                    icon={<PlusOutlined />}
                    onClick={onAddMore}
                    style={{ height: 56, fontSize: 17, fontWeight: 600, borderRadius: 14 }}
                >
                    Add More Lots
                </Button>
                <Button
                    block
                    size="large"
                    type="text"
                    icon={<AppstoreOutlined />}
                    onClick={() => navigate('/my-auctions')}
                    style={{ height: 48, fontSize: 15, color: '#595959' }}
                >
                    Go to My Auctions
                </Button>
            </Space>
        </div>
    );
};

export default WizardDoneStep;
